<template>
  <div class="rodeDetail">
    <div class="title">
      返程推荐 <span>线路详情</span>
    </div>
    <div class="detail_info">
      <div class="info_title">线路详情</div>
      <el-button @click="handleBackClick">返回</el-button>
      <el-button class="recomm"
                 @click="handleCancleClick">取消推荐</el-button>
      <el-button class="recomm_cancel"
                 v-if="data.type === '03'">已取消</el-button>
    </div>
    <div class="container">
      <el-table :data="data.list"
                style="width: 100%"
                class="table_main"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40"
                         fixed>
        </el-table-column>
        <el-table-column class-name="sourceNumber"
                         prop="goodsNum"
                         label="货源编号">
        </el-table-column>
        <el-table-column label="货主信息">
          <template slot-scope="scope">
            <div><span>公司名称：</span>{{scope.row.userCompanyName}}</div>
            <div><span>联系人姓名：</span>{{scope.row.userCompanyLinkman}}</div>
            <div><span>联系电话：</span>{{scope.row.userCompanyIphone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="位置信息">
          <template slot-scope="scope">
            <div><span>出发地：</span>{{scope.row.departLandDetails}}</div>
            <div><span>目的地：</span>{{scope.row.destinaDetails}}</div>
          </template>
        </el-table-column>
        <el-table-column label="货源信息">
          <template slot-scope="scope">
            <div><span>期望运费：</span>{{scope.row.expectFreight}}元/吨</div>
            <div><span>炼厂名称：</span>{{scope.row.refineryName}}</div>
            <div><span>原料：</span>{{scope.row.material}}</div>
            <div><span>重量：</span>{{scope.row.totalWeight}}吨</div>
            <div v-if="scope.row.tankBody==='0'"><span>罐体：</span>铝罐</div>
            <div v-if="scope.row.tankBody==='1'"><span>罐体：</span>铁罐</div>
            <div v-if="scope.row.tankBody==='2'"><span>罐体：</span>钢罐</div>
            <div v-if="scope.row.tankBody==='3'"><span>罐体：</span>铝合金</div>
            <div v-if="scope.row.tankBody==='4'"><span>罐体：</span>其他</div>
            <div><span>货源有效期：</span>{{scope.row.startTime}}至{{scope.row.endTime}}</div>
          </template>
        </el-table-column>
        <el-table-column label="招标详情">
          <template slot-scope="scope">
            <div><span>已匹配重量：</span><span>{{scope.row.totalWeight}}</span>吨</div>
            <div><span>已匹配车辆：</span>{{scope.row.matchWeight}}辆</div>
            <div><span>已谈成重量：</span>{{scope.row.talkWeight}}吨</div>
            <div><span>已谈成车辆：</span>{{scope.row.talkVehicle}}辆</div>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center"
                         width="97">
          <template slot-scope="scope">
            <div v-if="scope.row.goodsType==='01'">待匹配</div>
            <div v-else-if="scope.row.goodsType==='02'">已匹配</div>
            <div v-else-if="scope.row.goodsType==='03'"><span>已取消</span></div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         min-width="100"
                         align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.goodsType==='01'"
                       class="waiting"
                       @click="handleMatchClick(scope.row)">匹配车辆</el-button>
            <el-button v-else-if="scope.row.goodsType==='02'"
                       class="matched">已匹配</el-button>
            <el-button v-else-if="scope.row.goodsType==='03'"
                       class="cancel">已取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="提示"
               :visible.sync="matchingCar"
               class="matchingCarTable">
      <div class="matchingCarDetail">
        <p>匹配车辆前请先确定信息是否选择正确</p>
        <div><span>车辆服务费(￥)：</span>
          <el-input size="small"
                    v-model="amount"></el-input> 辆/次
        </div>
        <p class="remarks">服务费设置金额为0—300元</p>
      </div>
      <div class="matchingBtn">
        <div>取消</div>
        <div @click="handleConfirmClick">确定</div>
      </div>
    </el-dialog>
    <!-- <div class="pages">
            <span class="demonstartion"> 共{{data.total}}条记录</span>
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="data.pageSize"
                layout="prev, pager, next"
                :total="data.total"
                background
            >
            </el-pagination>
        </div> -->
  </div>
</template>
<script>
import {
  getRecommendRoleDetail,
  matchCars,
  cancleRoute
} from 'apis/index'
export default {
  data () {
    return {
      routeReturnId: '',
      amount: 0, // 服务费
      itemis: '',
      expectFreight: '', // 运费
      seniorGoodsId: '', // 货源
      matchingCar: false,
      data: {

      }
    }
  },
  methods: {
    getData () {
      getRecommendRoleDetail({
        routeReturnId: this.routeReturnId
      }).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.data = res.data.data
        }
      })
    },
    handleBackClick () {
      this.$router.go(-1)
    },
    handleCurrentChange (val) { // 切页切换
      //   let pageNum = val
      //   console.log(status)
      //   if (status === '') {
      //     privatelist({pageNum: pageNum}).then(res => {
      //       this.data = res.data.data.result
      //     })
      //   } else {
      //     privatelist({
      //       pageNum: pageNum
      //     }).then(res => {
      //       this.data = res.data.data.result
      //     })
      //   }
    },
    handleMatchClick (items) { // 单独匹配
      //   console.log('a', items)
      if (this.data.roleType === '0') { // 0是物流公司。不收服务费
        this.$confirm('确认匹配信息无误?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          matchCars({
            seniorGoodsId: items.goodsId,
            driverId: this.data.driverId,
            expectFreight: items.expectFreight,
            driverPaySum: this.amount
          }).then(res => {
            if (res.data.code === 0) {
              // console.log(res)
              this.data = res.data.data
              this.expectFreight = ''
              // this.amount = 0
              this.seniorGoodsId = ''
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消匹配'
          })
        })
      } else {
        this.expectFreight = items.expectFreight
        this.amount = 0
        this.seniorGoodsId = items.goodsId
        this.matchingCar = true
        // this.itemid=items.id
      }
    },
    handleConfirmClick () { // 确认匹配
      // console.log(

      //   'seniorGoodsId:', this.seniorGoodsId,
      //   'driverId:', this.data.driverId,
      //   'expectFreight:', this.expectFreight,
      //   'driverPaySum:', this.amount
      // )
      matchCars({
        seniorGoodsId: this.seniorGoodsId,
        driverId: this.data.driverId,
        expectFreight: this.expectFreight,
        driverPaySum: this.amount
      }).then(res => {
        if (res.data.code === 0) {
          this.matchingCar = false
          // console.log(res)
          this.data = res.data.data
          this.amount = 0
          this.expectFreight = ''
          this.seniorGoodsId = ''
        }
      })
    },
    handleCancleClick () {
      // console.log('aaa', this.routeReturnId)
      cancleRoute({
        routeReturnId: this.routeReturnId
      }).then(res => {
        // console.log(res)
      })
    }

  },
  mounted () {
    // console.log(this.$route.query.item)
    this.routeReturnId = this.$route.query.item
    if (this.routeReturnId) {
      this.getData()
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.rodeDetail
  height 100%
  .title
    padding-left 20px
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 77px #F7F9FB
    span
      color #212832
      margin-left 20px
  .detail_info
    width calc(100% - 40px)
    overflow hidden
    background #fff
    margin 0 auto
    .info_title
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../../assets/images/09/xq_icon.png') no-repeat center left 15px
      border-bottom 1px solid #CFD5DC
    .el-button
      float right
      padding 0
      background #1B88EE
      color #fff
      font-size 12px
      border 1px solid #1B88EE
      margin 10px
      width 78px
      height 28px
    .recomm
      border 1px solid #1b88ee
      color #1b88ee
      background #fff
    .recomm_cancel
      border 1px solid #CFD5DC
      color #fff
      background #CFD5DC
  .container
    margin-left 20px
    margin-right 20px
    height calc(100% - 150px)
    overflow hidden
    .table_main
      overflow-y hidden
      background #f7f9fb
    .el-table
      th
        background #e7f0f8
      .cell
        size12()
      td
        .cell
          size12()
          .waiting
            background #fff
            width 78px
            height 28px
            padding 0
            color #1B88EE
            font-size 12px
            border 1px solid #1B88EE
          .matched
            background #EDF0F4
            width 78px
            height 28px
            padding 0
            color #858C96
            font-size 12px
            border 1px solid #EDF0F4
          .cancel
            background #EDF0F4
            width 78px
            height 28px
            padding 0
            color #858C96
            font-size 12px
            border 1px solid #EDF0F4
  .matchingCarTable
    .el-dialog
      width 310px
      border-radius 5px
      overflow hidden
      top 20%
    .el-dialog__header
      height 42px
      padding 0 20px 0
      background #FFFFFF
      text-align center
      border-bottom 1px solid #CFD5DC
      .el-dialog__title
        line-height 42px
        font-size 13px
        color #858C96
        text-align center
      .el-dialog__headerbtn
        top 12px
        right 12px
      .el-dialog__close
        color #ADB4BE
        font-size 20px
    .el-dialog__body
      padding 0
      .matchingCarDetail
        padding 10px 10px
        p
          text-align center
          line-height 40px
        div
          font-size 13px
          padding-left 20px
          .el-input
            width 100px
            display inline-block
        .remarks
          font-size 12px
          color #f66
      .matchingBtn
        width 100%
        div
          width 50%
          height 34px
          display inline-block
          text-align center
          cursor pointer
          line-height 34px
          &:nth-child(1)
            background #F7F9FB
            color #858C96
          &:nth-child(2)
            background #1B88EE
            color #fff
  .el-table__header-wrapper
    background #e7f0f8
  .el-table td, .el-table th
    vertical-align top
</style>
